export default function groupByConsecutiveSpeakers(segments, limit = 50) {
  const groupedSegments = [];
  let currentGroup = [];

  segments?.forEach((segment, index) => {
    if (
      currentGroup.length < limit &&
      (currentGroup.length === 0 || currentGroup[0].speaker === segment.speaker)
    ) {
      currentGroup.push(segment);
    } else {
      groupedSegments.push(currentGroup);
      currentGroup = [segment];
    }

    if (index === segments.length - 1 || currentGroup.length === limit) {
      groupedSegments.push(currentGroup);
      currentGroup = [];
    }
  });

  return groupedSegments;
}
